import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import { useConsistentClient } from "@/premium/hooks/consistentClient";
import { Footer } from "@/premium/themedComponents/Footer";
import { MenuBar } from "@/premium/themedComponents/MenuBar";
import { OldFooter } from "@/premium/themedComponents/OldFooter";
import { enablePlansPageRedesign } from "@/utils/featureFlags";
import { ThemedHeader } from "./ThemedHeader";

import "./ContentContainer.scss";

export const ContentContainer: FC<PropsWithChildren<{ noBackground?: boolean }>> = ({ children, noBackground }) => {
  useConsistentClient();

  return (
    <>
      <div className={classNames("premium-content-container", { "premium-content-container--no-background": noBackground })}>
        {enablePlansPageRedesign() ? <MenuBar /> : <ThemedHeader />}
        {children}
      </div>
      {enablePlansPageRedesign() ? <Footer /> : <OldFooter />}
    </>
  );
};
